import type { NextRouter } from "next/router";

const isConfirmationStep = (router: NextRouter): boolean =>
  router.isReady && router.query.step === "3";

export { isConfirmationStep };
